import { ChangeDetectionStrategy, Component } from '@angular/core';
import { clientConfig, isDevEnvironment } from 'src/client-config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FooterComponent {
  releaseId = '';

  constructor() {
    this.releaseId = (isDevEnvironment()
      ? clientConfig?.deploymentInfo?.releaseId
      : clientConfig?.deploymentInfo?.versionName) ?? '';
  }  
}
